import { JIA_MENG_LOGIN_PATH, LOGIN_PATH } from '@hlj/hlj-constant'
import { isStoreAccount } from '..'
import { PRODUCT_PRO, SHOP_PRODUCTS_PATH } from '@constant'
import { getJti } from './auth'

export const getLoginPath = () => {
  return isStoreAccount() ? JIA_MENG_LOGIN_PATH : LOGIN_PATH
}

export const getProductPathById = productId => {
  const p = {
    [`${PRODUCT_PRO}`]: SHOP_PRODUCTS_PATH
  }

  return p[Number(productId)]
}

export const isDevHost = () => {
  const regDevHost = /\d+(\.\d+){3}|:\d+|dev\.|test/ // ip、带端口号、包含dev、test的认为是devhost
  return window.location.host.match(regDevHost) !== null
}

export const getJtiPath = path => {
  return path + `?jti=${getJti()}`
}

/**
 * 跳转商家中心
 */
export const goToMerchantCenter = id => {
  window.open(
    // eslint-disable-next-line
    `${__HCY_DOMAIN__}:${
      window.location.port
    }/hlj-merchant-center/dist/index.html#/redirect/login?type=0&centerPath=${id}&jti=${getJti()}`
  )
}
